import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { fontSize02, fontSize03 } from '../../tokens';
export var makeTypography = function makeTypography() {
  var typography = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fontSize = typography.fontSize || fontSize02;
  var htmlFontSize = typography.htmlFontSize || fontSize03;
  var factor = fontSize / fontSize02;
  return _objectSpread(_objectSpread({}, typography), {}, {
    fontFamily: typography.fontFamily || 'Roboto, sans-serif',
    fontSize: fontSize,
    htmlFontSize: htmlFontSize,
    pixelToRem: function pixelToRem(size) {
      if (size === 0) {
        return '0';
      }

      if (typeof size === 'string') {
        return size;
      }

      return "".concat(size / htmlFontSize * factor, "rem");
    }
  });
};